// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1hUNS","header":"ReportDetails_header__VTQCw","title":"ReportDetails_title__3c643","left":"ReportDetails_left__3X-WI"};